const betaLight = {
  id: 'betaLight',
  displayName: 'Beta Light',
  enabled: false,
  graph: {
    writeSample: '#E86000', writeTrend: 'rgba(232, 96, 0, 0.78)',
    writeMax: '#D4860A', writeMin: '#9E3A18', writeLatency: '#E86000',
    readSample: '#0277BD', readTrend: 'rgba(2, 119, 189, 0.78)',
    readMax: '#0288D1', readMin: '#01579B', readLatency: '#0277BD',
  },
  canvas: {
    chartBg: '#F5F5F0', gridColor: '#D8D8D0', textColor: '#4A4A4A',
  },
};
export default betaLight;
